import React, { forwardRef } from 'react';
import * as RadixTabsPrimitive from '@radix-ui/react-tabs';
import { styled } from '../../theme';
import { GDSCustomizableComponent } from '../../types';
import { GenesisCoreInspector } from '../../test-utils/genesis-core-inspector';

export interface GDSTabsProps
  extends RadixTabsPrimitive.TabsProps,
    GDSCustomizableComponent {}

export const DISPLAY_NAME = 'Tabs';

export const BaseTabsRoot = styled(RadixTabsPrimitive.Root, {
  width: '100%',
});

export const TabsRoot = forwardRef<HTMLDivElement, GDSTabsProps>(
  (
    {
      activationMode = 'manual',
      children,
      className,
      css,
      defaultValue,
      onValueChange,
      value,
      'data-testid': testId = `GDS-${DISPLAY_NAME}`,
      ...props
    },
    ref,
  ) => (
    <GenesisCoreInspector displayName={DISPLAY_NAME}>
      <BaseTabsRoot
        ref={ref}
        activationMode={activationMode}
        className={[`GDS-tabs`, className].join(' ')}
        css={css}
        defaultValue={defaultValue}
        onValueChange={onValueChange}
        value={value}
        data-testid={testId}
        {...props}
      >
        {children}
      </BaseTabsRoot>
    </GenesisCoreInspector>
  ),
);
